// extracted by mini-css-extract-plugin
export default {"container":"Incident_container__L0ckl","page":"Incident_page__AEVvl","section":"Incident_section__Xw+Cs"};